// extracted by mini-css-extract-plugin
export default {"root":"style-module__root___rhYcU","root__item":"style-module__root__item___uUD0I","root__item_active":"style-module__root__item_active___zyaS2","root__item_counter":"style-module__root__item_counter___FIiaj"};
    if(module.hot) {
      // 1697460464234
      var cssReload = require("../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  